document.addEventListener('DOMContentLoaded', () => {
    // Find numbers and set them to be animated
    const statElements = document.querySelectorAll('.stat-block--num');

    // Function to format numbers with commas and up to 2 decimal places
    const formatNumber = (number) => {
        //Nicole wins!
        const lang = document.documentElement.lang === 'fr-FR' ? 'fr-FR' : 'en-US';
        console.log(lang);
        console.log(document.documentElement.lang);
        return new Intl.NumberFormat(lang, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }).format(number);        
    };

    


    const animateNumbers = (element) => {
        // Read the data-count attribute and remove any commas before parsing
        const statNumber = parseFloat(element.getAttribute('data-count').replace(/,/g, ''));
        let currentStat = 0;

        // Determine the increment based on the number size
        const increment = statNumber / 150;

        const updateStat = () => {
            currentStat += increment;
            if (currentStat >= statNumber) {
                // Ensure the final value matches the target number exactly
                element.innerHTML = `<strong>${formatNumber(statNumber)}</strong>`;
            } else {
                element.innerHTML = `<strong>${formatNumber(currentStat)}</strong>`;
                requestAnimationFrame(updateStat);
            }
        };

        updateStat();
    };

    // Ensure numbers animate only when in the viewport
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const element = entry.target;
                    animateNumbers(element);
                    // Stop observing once animated
                    observer.unobserve(element);
                }
            });
        },
        // Trigger when 10% of the element is visible
        { threshold: 0.1 }
    );

    // Loop through & add each to the observer so the view can be tracked
    statElements.forEach((el) => {
        observer.observe(el);
    });
});



// WEBPACK FOOTER //
// ./src/js/vanilla/successStatistics.js